import { z } from 'zod';
import { DOCUMENT_COMPLIANCE_STATUSES } from './configurable-engine.js';
import { ChecklistTemplateResponseSchema, ChecklistInstanceResponseSchema } from './checklist.js';

// ---------------------------------------------------------------------------
// GET /public/fleet-qr/:token — fleet-qr-compliance PR3 (design.md §4.4).
// Public, session-less response — the token itself is the only gate. Never
// exposes a raw fileId (design.md §4.5) — `downloadUrl` is a short-lived
// signed URL, null when the document has no file attached yet.
// ---------------------------------------------------------------------------

export const FleetQrDocumentSchema = z.object({
  id: z.string().uuid(),
  documentTypeId: z.string().uuid(),
  /** Human label (e.g. "VTV") — never show documentTypeId raw in the UI. */
  documentTypeName: z.string(),
  documentNumber: z.string().nullable(),
  expiresAt: z.string().nullable(),
  status: z.enum(DOCUMENT_COMPLIANCE_STATUSES),
  downloadUrl: z.string().nullable(),
});
export type FleetQrDocument = z.infer<typeof FleetQrDocumentSchema>;

export const FleetQrAssetSchema = z.object({
  id: z.string().uuid(),
  serialNumber: z.string(),
  description: z.string().nullable(),
});
export type FleetQrAsset = z.infer<typeof FleetQrAssetSchema>;

export const FleetQrResponseSchema = z.object({
  asset: FleetQrAssetSchema,
  documents: z.array(FleetQrDocumentSchema),
  checklistTemplates: z.array(ChecklistTemplateResponseSchema),
  latestChecklistInstance: ChecklistInstanceResponseSchema.nullable(),
});
export type FleetQrResponse = z.infer<typeof FleetQrResponseSchema>;
